import { AxiosResponse } from 'axios';

import { ILandlortReferral } from '../../shared/ts/landlord-referrals';
import httpRequest from '../httpRequest';

const tenantLandlordReferralApi = {
  getLandlordReferrals: async ({
    webpage_source,
    userId,
    bookingId,
    visitId,
  }: {
    webpage_source: string;
    userId?: number;
    bookingId?: string;
    visitId?: string;
  }) => {
    const queryParams = new URLSearchParams();
    if (userId) queryParams.append('user_id', userId.toString());
    if (bookingId) queryParams.append('booking_id', bookingId);
    if (visitId) queryParams.append('visit_id', visitId);
    queryParams.append('webpage_source', webpage_source);
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `referral?${queryParams.toString()}`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },

  createLandlordReferralsForBooking: async ({
    userId,
    bookingId,
    webpageSource,
    data,
  }: {
    userId: number;
    bookingId: string;
    webpageSource: string;
    data: Pick<
      ILandlortReferral,
      'lead_name' | 'lead_phone_number' | 'time_to_contact'
    >;
  }) => {
    const { status } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/users/${userId}/bookings/${bookingId}/referral`,
      method: 'POST',
      data: { ...data, webpage_source: webpageSource },
    })) as AxiosResponse;

    return status;
  },

  createLandlordReferralsForVisit: async ({
    visitId,
    webpageSource,
    data,
  }: {
    visitId: string;
    webpageSource: string;
    data: Pick<
      ILandlortReferral,
      'lead_name' | 'lead_phone_number' | 'time_to_contact'
    >;
  }) => {
    const { status } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/visits/${visitId}/referral`,
      method: 'POST',
      data: { ...data, webpage_source: webpageSource },
    })) as AxiosResponse;

    return status;
  },
};

export default tenantLandlordReferralApi;
